// extracted by mini-css-extract-plugin
export default {"backdrop":"AddEditForm_backdrop__UboFk","modal":"AddEditForm_modal__p50nZ","form":"AddEditForm_form__eMN8x"};